var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6342 12.7216C19.6702 12.6562 19.723 12.6018 19.7872 12.5638C19.8514 12.5259 19.9246 12.5059 19.9992 12.5059C20.0738 12.5059 20.147 12.5259 20.2112 12.5638C20.2754 12.6018 20.3282 12.6562 20.3642 12.7216L22.8242 17.3916C22.8829 17.4997 22.9648 17.5935 23.064 17.6662C23.1632 17.739 23.2773 17.7889 23.398 17.8123C23.5188 17.8357 23.6433 17.8321 23.7625 17.8017C23.8817 17.7713 23.9927 17.7149 24.0875 17.6366L27.6517 14.5832C27.7201 14.5276 27.8044 14.4951 27.8925 14.4904C27.9806 14.4857 28.0679 14.5091 28.1418 14.5572C28.2157 14.6053 28.2725 14.6756 28.3039 14.758C28.3354 14.8404 28.3398 14.9306 28.3167 15.0157L25.955 23.5541C25.9068 23.7288 25.803 23.883 25.6592 23.9934C25.5155 24.1038 25.3396 24.1643 25.1584 24.1657H14.8409C14.6595 24.1645 14.4835 24.104 14.3395 23.9937C14.1956 23.8833 14.0916 23.7289 14.0434 23.5541L11.6825 15.0166C11.6594 14.9315 11.6639 14.8412 11.6953 14.7588C11.7268 14.6764 11.7835 14.6061 11.8575 14.558C11.9314 14.5099 12.0187 14.4866 12.1067 14.4912C12.1948 14.4959 12.2791 14.5284 12.3475 14.5841L15.9109 17.6374C16.0057 17.7158 16.1167 17.7722 16.2359 17.8025C16.3551 17.8329 16.4796 17.8365 16.6004 17.8131C16.7212 17.7897 16.8352 17.7398 16.9345 17.6671C17.0337 17.5943 17.1156 17.5005 17.1742 17.3924L19.6342 12.7216Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 27.5H25.8346",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.46c7eeb4811a6e7a7e595f3608998067.svg";
export { ForwardRef as ReactComponent };